module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.partials.mag_diff_well))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "min-height": "352px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_c('i', {
    staticClass: "icon-shuffle font-2xl"
  }), _vm._v(" "), _c('span', {
    staticClass: "px-2"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.status))])]), _vm._v(" "), (_vm.mag_dif_well === 'ON') ? _c('button', {
    staticClass: "btn col-md-5 btn-success btn-lg btn-block",
    on: {
      "click": function($event) {
        _vm.changeStatusMagDif('well', 'OFF')
      }
    }
  }, [_vm._v("ON")]) : (_vm.mag_dif_well === 'OFF') ? _c('button', {
    staticClass: "btn col-md-5 btn-btn-danger btn-lg btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.changeStatusMagDif('well', 'ON')
      }
    }
  }, [_vm._v("OFF")]) : _c('button', {
    staticClass: "btn col-md-5 btn-default btn-lg btn-block",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("S/D")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.partials.shuntings))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "min-height": "352px"
    }
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.list_events_well,
      "paginate": true,
      "perPage": 4,
      "defaultSortBy": {
        field: 'date',
        type: 'desc'
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_c('td', {
          class: props.row.value
        }, [_vm._v(_vm._s(props.row.date))]), _vm._v(" "), _c('td', {
          class: props.row.value
        }, [_vm._v(_vm._s(props.row.shunter))]), _vm._v(" "), _c('td', {
          class: props.row.value
        }, [_vm._v(_vm._s(props.row.value))])]
      }
    }])
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.partials.mag_diff_raft))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "min-height": "352px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_c('i', {
    staticClass: "icon-shuffle font-2xl"
  }), _vm._v(" "), _c('span', {
    staticClass: "px-2"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.status))])]), _vm._v(" "), (_vm.mag_dif_raft === 'ON') ? _c('button', {
    staticClass: "btn col-md-5 btn-success btn-lg btn-block",
    on: {
      "click": function($event) {
        _vm.changeStatusMagDif('raft', 'OFF')
      }
    }
  }, [_vm._v("ON")]) : (_vm.mag_dif_raft === 'OFF') ? _c('button', {
    staticClass: "btn col-md-5 btn-danger btn-lg btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.changeStatusMagDif('raft', 'ON')
      }
    }
  }, [_vm._v("OFF")]) : _c('button', {
    staticClass: "btn col-md-5 btn-default btn-lg btn-block",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("S/D")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.partials.shuntings))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "min-height": "352px"
    }
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.list_events_raft,
      "paginate": true,
      "perPage": 4,
      "defaultSortBy": {
        field: 'date',
        type: 'desc'
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_c('td', {
          class: props.row.value
        }, [_vm._v(_vm._s(props.row.date))]), _vm._v(" "), _c('td', {
          class: props.row.value
        }, [_vm._v(_vm._s(props.row.shunter))]), _vm._v(" "), _c('td', {
          class: props.row.value
        }, [_vm._v(_vm._s(props.row.value))])]
      }
    }])
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d7b2618"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/partials/shuntting_partials/DiffShunting.vue
// module id = 560
// module chunks = 1